"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_form_controls_1 = require("@ryerson/frontend.form-controls");

var frontend_button_1 = require("@ryerson/frontend.button");

var react_1 = require("@emotion/react");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_quantity_uom_inputs_1 = require("@ryerson/frontend.quantity-uom-inputs");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_application_1 = require("@ryerson/frontend.application");

var ItemLink_1 = require("../common/ItemLink");

var SearchResultsContext_v2_1 = require("./SearchResultsContext_v2");

var ResultItemWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding: 10px 0px 20px 0px;\n\tborder-bottom: 1px solid rgba(82, 92, 107, 0.1);\n\tbackground: ", ";\n\twidth: 100%;\n"])), function (props) {
  return props.bgColor;
});
var FlexItemWithMargin = (0, styled_1.default)(frontend_layout_1.FlexItem)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmargin-top: 7px;\n"])));
var productInfoWrapperStyles = (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tpadding-left: 20px;\n\twidth: 100%;\n"])));
var productTitleStyles = (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tmargin-bottom: 5px;\n"])));
var MeasureDropdown = (0, styled_1.default)(frontend_form_controls_1.Dropdown)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t@media only screen and (max-width: ", ") {\n\t\tpadding-left: 20px;\n\t\ttext-transform: lowercase;\n\t}\n"])), function (props) {
  return props.theme.breakpoints.lg;
});
var measureDropdownStyles = (0, react_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\twidth: 80px;\n\tfont-size: 14px;\n\ttext-transform: lowercase;\n\t.select {\n\t\theight: 30px !important;\n\t\tpadding-left: 20px;\n\t}\n"])));
var DropdownSizeWrapper = styled_1.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\theight: 30px;\n"])));
var ImageContainer = styled_1.default.img(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\theight: 50px;\n\twidth: 50px;\n\tobject-fit: contain;\n\t", ";\n"])), function (props) {
  var breakpoint = props.breakpoint,
      bgColor = props.bgColor;
  return (0, react_1.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t\t@media only screen and (max-width: ", ") {\n\t\t\t\theight: 60px;\n\t\t\t\twidth: 60px;\n\t\t\t}\n\t\t"])), bgColor, breakpoint);
});

var SearchResultItemMobile = function SearchResultItemMobile(_ref) {
  var item = _ref.item,
      qtyUomOption = _ref.qtyUomOption,
      pricingUomOption = _ref.pricingUomOption,
      quantity = _ref.quantity,
      quantityMeasure = _ref.quantityMeasure,
      pricingMeasure = _ref.pricingMeasure,
      isDebouncing = _ref.isDebouncing,
      hasError = _ref.hasError,
      setHasError = _ref.setHasError,
      leadTimeDays = _ref.leadTimeDays,
      addDefaultSrc = _ref.addDefaultSrc,
      getCorrectCase = _ref.getCorrectCase,
      canCartViewEdit = _ref.canCartViewEdit,
      generateProductUrl = _ref.generateProductUrl,
      onQuantityUpdate = _ref.onQuantityUpdate,
      onPricingMeasureChange = _ref.onPricingMeasureChange,
      onClickAddToCart = _ref.onClickAddToCart,
      index = _ref.index;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      header = _theme$colors$primary.header,
      lighterGray = _theme$colors$primary.lighterGray,
      white = _theme$colors$primary.white;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      language = _ref3.localization.language;

  var _ref4 = (0, SearchResultsContext_v2_1.useSearchResults)(),
      stateMessenger = _ref4.stateMessenger,
      storeDirectory = _ref4.storeDirectory,
      content = _ref4.content;

  var itemCategory = getCorrectCase(item.category);
  var itemForm = getCorrectCase(item.form);
  var itemShape = item.shape !== "N/A" ? getCorrectCase(item.shape) : "";
  var imageSource = "/static-assets/images/renderings/".concat(itemCategory).concat(itemForm).concat(itemShape, ".png");
  var disabledButton = quantity === 0 || typeof quantity === "undefined" || isDebouncing || hasError || leadTimeDays === undefined;
  return (0, jsx_runtime_1.jsxs)(ResultItemWrapper, {
    css: index && index > 0 ? {
      paddingTop: 20
    } : {},
    bgColor: lighterGray,
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      children: (0, jsx_runtime_1.jsx)(ImageContainer, {
        bgColor: white,
        onError: function onError(event) {
          return addDefaultSrc(event);
        },
        src: imageSource
      })
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      direction: "column",
      style: productInfoWrapperStyles,
      children: [(0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          style: productTitleStyles,
          children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
            size: "xs",
            color: header,
            children: [item.category, " ", item.form]
          })
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, ItemLink_1.getItemLink)(item, generateProductUrl, storeDirectory)
        }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "sm",
            color: header,
            children: item.description
          })
        })]
      }), (0, jsx_runtime_1.jsx)(FlexItemWithMargin, {
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          alignItems: "center",
          children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
            size: "sm",
            color: header,
            children: [content.quantity, ":"]
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            justifyContent: "flex-end",
            children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              children: (0, jsx_runtime_1.jsx)(frontend_quantity_uom_inputs_1.QuantityUOM, {
                quantityUomOptions: qtyUomOption,
                id: item.id,
                itemData: item,
                size: "sm",
                type: "primary",
                disabled: false,
                handleValidationResponse: function handleValidationResponse(hasError) {
                  return setHasError(hasError);
                },
                isSubmitted: true,
                quantityValue: Number(quantity),
                uomValue: quantityMeasure,
                handleChange: onQuantityUpdate,
                stateMessenger: stateMessenger
              })
            })
          })]
        })
      }), (0, jsx_runtime_1.jsx)(FlexItemWithMargin, {
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          alignItems: "center",
          children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
            size: "sm",
            color: header,
            children: [content.priceUom, ":"]
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            style: measureDropdownStyles,
            children: (0, jsx_runtime_1.jsx)(DropdownSizeWrapper, {
              children: (0, jsx_runtime_1.jsx)(MeasureDropdown, {
                size: "sm",
                onChange: onPricingMeasureChange,
                options: pricingUomOption,
                value: pricingMeasure,
                language: language,
                theme: theme
              })
            })
          })]
        })
      }), (0, jsx_runtime_1.jsx)(FlexItemWithMargin, {
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
            size: "xs",
            color: header,
            children: [content.leadTime, ":"]
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            size: "xs",
            color: header,
            children: (0, frontend_common_1.getLeadTimeRangeDisplay)(leadTimeDays, language)
          })]
        })
      }), canCartViewEdit() && (0, jsx_runtime_1.jsx)(FlexItemWithMargin, {
        children: (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
          fullwidth: true,
          disabled: disabledButton,
          label: content.addToCart,
          paddingType: "relaxed",
          onClick: onClickAddToCart
        })
      })]
    })]
  });
};

exports.default = SearchResultItemMobile;